import {breadcrumbShortener, appSearchSuggestion, setAfgRemoveLink} from "~/public/utilities/utilities";
import productSlider from "./productSlider";
(function ($) {
	// Main menu close button.
	$(document.body).on('click', '.close-nav-btn', function(e) {
		e.preventDefault();
		$('.parent-nav').removeClass('active');
		$('#black-overlay').removeClass('active-body-cover');
	});

	// DOM ready
	$(function() {
		// Main menu and sidebar menu start.
		let mobSearchIcon = $('.mob-search-icon');

		if (mobSearchIcon.length) {
			mobSearchIcon.click(function () {
				$(this).toggleClass('active');
				$('#header-search').toggleClass('active');
				$('#black-overlay').toggleClass('active-body-cover');
			});
		}

		if ('' !== sonicGlobal.year && '' !== sonicGlobal.make && '' !== sonicGlobal.model) {
			let myv = document.querySelectorAll('.myVehicle');

			for (let i = 0; i < myv.length; i++) {
				myv[i].href = '/afg/' + sonicGlobal.urlMake + '/' + sonicGlobal.urlModel + '/' + sonicGlobal.year;
				myv[i].innerHTML = '<span class="ava-icon position-relative d-inline-block"></span> Your ' + sonicGlobal.displayModel;
			}
		}
		// Main menu and sidebar menu end.

		if ($('.newsletter').length > 0){
			$('.newsLetterSection').appendTo('.newsletter');
			$('.newsLetterSection').css('display','block');
		}

		// Slice the username character length
		let userFirstName = $('.userFirstName');

		if (userFirstName.length) {
			let loginUserName = userFirstName.html();

			if (loginUserName.length > 18) {
				// With included Welcome
				let sliceUserName = loginUserName.slice(0, 18);

				userFirstName.html(sliceUserName + '...');
			}
		}

		// Scroll Spy functionality with Anchor link jump on click
		// Top ribbon height offset.
		let topRibbon = $('.top-ribbon'),
			topRibbonHeight = topRibbon.height();

		if (topRibbonHeight) {
			// Offset the Scrollspy targets based on the top ribbon and menu height.
			let setVehicleWrap = topRibbon.find('.ribbon-set-vehicle-wrap'),
				styleString = `.anchor-for-fixed-header:target {padding-top: ${topRibbonHeight}px !important;}`;

			$(`<style>${styleString}</style>`).appendTo('head');
			// Initialize Scrollspy.
			$(document.body).scrollspy({target: '#category-scroll-spy', offset: topRibbonHeight});
			// Horizontally scroll Scrollspy link into view.
			$(window).on('activate.bs.scrollspy', function(event, data) {
				let target = $(`a[href="${data.relatedTarget}"]`);

				if (target.length) {
					let container = target.parent().parent(),
						setVehicleOffset = setVehicleWrap.length ? setVehicleWrap.outerWidth(true) : 0;
					container.animate({'scrollLeft': container.scrollLeft() + target.position().left - setVehicleOffset - 16}, 400);
				}
			});
		}

		if (window.innerHeight < 768 && window.innerWidth > window.innerHeight) {
			// Landscape.
			if ($('.top-ribbon-mobile').length > 0) {
				$('.top-ribbon-mobile').removeClass('position-sticky');
			}
		}
	});
})(jQuery);

/**
 * GLOBAL JS Sonic Electronx
 * This file only inludes global functions
 *
 * Apply these rules globally
 * If any container that needs to stick to the top while scrolling
 *
 */
window.GlobalInIt = (() => {
	const mainTasks = {
		render: function () {
			this.ribbonSlider();
			this.customSlider();
			this.makeFixedMethod();
			this.MAINMENU();
			this.notifyMeController();
			this.showDetails();
			this.landingPageSidebarOverlayController();
			this.fancyBoxController();
			this.whyShopWithUsButtonController();
			this.firstTimeUserEmailSignup();
			this.advertisingTracker();
			appSearchSuggestion();
			breadcrumbShortener();
			setAfgRemoveLink();
			productSlider.init();
		},
		globalElement: {
			makeFixed: document.querySelectorAll('.makeFixed')
		},
		/**
		 * While Scrolldown and reach the pass the bottom of the makeFixed element, make those element to the the top
		 * @program  also it will check of the height of the main navigaion
		 */
		makeFixedMethod: function () {
			this.globalElement.makeFixed.forEach((el) => {
				let topSet = el.offsetTop;
				let ElHeight = el.offsetHeight;
				let total = topSet + ElHeight;

				window.addEventListener('scroll', (e) => {
					if (document.body.scrollTop > total || document.documentElement.scrollTop > total) {
						el.classList.add('FixedMe');
					} else {
						el.classList.remove('FixedMe');
					}
				});
			});
		},

		ribbonSlider: function () {
			let topRibbon = $('.top-ribbon'),
				setVehicleWrap = topRibbon.find('.ribbon-set-vehicle-wrap'),
				topRibbonOuterWidth = topRibbon.outerWidth() - (setVehicleWrap.length ? setVehicleWrap.outerWidth(true) : 0),
				topRibbonScrollBar = topRibbon.find('.horizontalCustomScrollbar'),
				topRibbonElements = topRibbonScrollBar.find('a'),
				topRibbonFirstElement = topRibbonElements.eq(0),
				topRibbonLastElement = topRibbonElements.last(),
				topRibbonArrows = topRibbon.find('.arrow'),
				topRibbonArrowRight = topRibbon.find('.arrowRight'),
				topRibbonArrowLeft = topRibbon.find('.arrowLeft'),
				topRibbonWidth = 0;
				topRibbonElements.each(function (){
					topRibbonWidth += ($(this).outerWidth() + 16);
				});

			if ($('.top-ribbon-mobile').length < 1) {
				if (topRibbonWidth > topRibbonOuterWidth) {
					topRibbonArrowRight.show();
				}
				$(window).on('resize', function() {
					topRibbonOuterWidth = topRibbon.outerWidth() - (setVehicleWrap.length ? setVehicleWrap.outerWidth(true) : 0);
					(topRibbonWidth > topRibbonOuterWidth) ? topRibbonArrowRight.show() : topRibbonArrowRight.hide();
				});
				topRibbonArrows.click(function() {
					let x;

					if ($(this).hasClass('arrowRight')) {
						x = (topRibbonOuterWidth / 2) + topRibbonScrollBar.scrollLeft();
						topRibbonScrollBar.animate({ scrollLeft: x });
						(topRibbonLastElement.isInViewport()) ? topRibbonArrowRight.hide() : topRibbonArrowRight.show();
						if (x > 0) {
							topRibbonArrowLeft.show();
						}
					} else {
						x = (topRibbonOuterWidth / 2) - topRibbonScrollBar.scrollLeft();
						topRibbonScrollBar.animate({ scrollLeft: -x });
						(topRibbonFirstElement.isInViewport()) ? topRibbonArrowLeft.hide() : topRibbonArrowLeft.show();
						topRibbonArrowRight.show();
					}
				});
				$.fn.isInViewport = function() {
					let $this = $(this),
						elementLeft = $this.offset().left,
						elementRight = elementLeft + $this.outerWidth(),
						viewportLeft = $(window).scrollLeft(),
						viewportRight = viewportLeft + $(window).width();

					return elementRight > viewportLeft && elementLeft < viewportRight;
				};
			}
		},
		/**
		 * Utility for custom horizontal carousel slider.
		 */
		customSlider: function () {
			let customSlider = $('.customSlider');
			customSlider.each(function () {
				let $this = $(this),
					sliderElementOuterWidth = $this.outerWidth(),
					sliderScrollBar = $this.find('.horizontalCustomScrollbar'),
					sliderElements = sliderScrollBar.find('.sliderElement'),
					sliderFirstElement = sliderElements.eq(0),
					sliderLastElement = sliderElements.last(),
					sliderArrows = $this.find('.arrow'),
					sliderArrowRight = $this.find('.arrowRight'),
					sliderArrowLeft = $this.find('.arrowLeft'),
					sliderElementWidth = 0;

				sliderElements.each(function (){
					sliderElementWidth += ($(this).outerWidth() + 16);
				});

				let customSliderWidth = sliderElementWidth;

				if (!window.sonicGlobal.isMobile) {
					if (customSliderWidth > sliderElementOuterWidth) {
						sliderArrowRight.show();
					}
					$(window).on('resize', function() {
						sliderElementOuterWidth = $this.outerWidth();
						(customSliderWidth > sliderElementOuterWidth) ? sliderArrowRight.show() : sliderArrowRight.hide();
					});
					sliderArrows.click(function() {
						let x;

						if ($(this).hasClass('arrowRight')) {
							x = (sliderElementOuterWidth / 2) + sliderScrollBar.scrollLeft();
							sliderScrollBar.animate({ scrollLeft: x });
							(sliderLastElement.isInViewport()) ? sliderArrowRight.hide() : sliderArrowRight.show();
							if (x > 0) {
								sliderArrowLeft.show();
							}
						} else {
							x = (sliderElementOuterWidth / 2) - sliderScrollBar.scrollLeft();
							sliderScrollBar.animate({ scrollLeft: -x });
							(sliderFirstElement.isInViewport()) ? sliderArrowLeft.hide() : sliderArrowLeft.show();
							sliderArrowRight.show();
						}
					});
					$.fn.isInViewport = function() {
						let $this = $(this),
							elementLeft = $this.offset().left,
							elementRight = elementLeft + $this.outerWidth(),
							viewportLeft = $(window).scrollLeft(),
							viewportRight = viewportLeft + $(window).width();

						return elementRight > viewportLeft && elementLeft < viewportRight;
					};
				}
			});
		},
		/**
		 *	Open Fancybox with specific width and height on notify Me Button click.
		 */
		notifyMeController: function () {
			// notify Me Button click
			$(document.body).on('click', '.notifyMeButton', function(event) {
				event.preventDefault();

				let $link = $(this),
					href = $link.attr('href'),
					width = 300;

				if (window.innerWidth > 600) {
					width = 500;
				}

				$.fancybox({
					type: 'iframe',
					href: href + (href.indexOf('?') === -1 ? '?' : '&') + 'fancyboxed=1',
					width: width,
					height: 220,
					fitToView: true
				});

				// GTM event fire
				dataLayer = dataLayer || [];
				dataLayer.push({'event': 'notifyMe'});
			});
		},

		/**
		 * Default read more read less
		 */
		showDetails: function(){
			let readMore = document.querySelectorAll('.readMoreContent');

			if (typeof readMore !== 'undefined' && readMore.length) {
				readMore.forEach(function(par) {
					let str = par.innerHTML,
						strTotalLen = (window.innerWidth > 650) ? 500 : 175,
						strlen = (window.innerWidth > 650) ? 450 : 150;

					if (str.length >= strTotalLen && str.length > strlen) {
						let res = str.substring(0, strlen);

						par.innerHTML = res + '...';
						par.style.display = 'inline';
						par.insertAdjacentHTML('afterend', '<span data-text-swap="Read less" class="inline-block ml-2 btn-link custom-font-weight-600" style="text-decoration:underline; font-size:14px;">Read more</span>');
						par.nextElementSibling.addEventListener('click', function() {
							let thisEl = par.nextElementSibling;

							if (thisEl.getAttribute('data-text-swap') == thisEl.innerHTML) {
								thisEl.innerHTML = thisEl.getAttribute('data-text-original');
								res = str.substring(0, strlen);
								par.innerHTML = res + '...';
							} else {
								thisEl.setAttribute('data-text-original', thisEl.innerHTML);
								thisEl.innerHTML = thisEl.getAttribute('data-text-swap');
								res = str.substring(0, 500000000000); //Never gonna be happen
								par.innerHTML = res;
							}
						});
					}
				});
			}
		},
		/**
		 * Even handler for vehicle selector on pages built with landing page tool in responsive theme.
		 * @returns {undefined}
		 */
		landingPageSidebarOverlayController: function () {
			$(document.body).on('click', '.responsiveContainer .select-vehicle', function() {
				sonicGlobal.overlayActivate();
			});
		},
		MAINMENU: () => {
			/**
			 * @copy from old header/footer menu JS code
			 * @ik need to refactor it
			 */
			$('.hamburger').click(function() {
				$('.hero-menu').addClass('hero-active')
					.animate({left: 0}, 400);
				$(this).addClass('active');
				sonicGlobal.overlayActivate(true);
			});
			let toggleHamburgerGarage = $('.toggle-hamburger-garage'),
				toggleHamburgerShop = $('.toggle-hamburger-shop');
			toggleHamburgerShop.click(function (e) {
				toggleHamburgerGarage.removeClass("active");
				$(this).addClass("active");
				$(".garage-hamburger").hide();
				$(".hamburger-shop-menu").show();
			});
			toggleHamburgerGarage.click(function (e) {
				$(this).addClass("active");
				toggleHamburgerShop.removeClass("active");
				$(".garage-hamburger").show();
				$(".hamburger-shop-menu").hide();
			});
			$('.close-hero-menu').click(function () {
				$('.hero-menu').removeClass('hero-active')
					.animate({left: '-50rem'}, 400);
				sonicGlobal.overlayDeactivate();
			});
			$('#black-overlay').click(function () {
				sonicGlobal.overlayDeactivate();
				$(this).removeClass('active-body-cover');
				$('.hamburger').removeClass('active');
				$('.hero-menu').removeClass('hero-active')
					.animate({left: '-50rem'}, 400);
				$('.main-navigation .parent-nav').removeClass('active');
				$('.mega-menu-parrent').find('.close-nav-btn').remove();
				$('#header-search').removeClass('active');
				$('.mob-search-icon').removeClass('active');
				$('.ship-details-msg-box').removeClass('active');
			});
			/** SIDEBAR MENU START**/
			$('.menu li .menu-title-section').click(function (e) {
				e.preventDefault();
				$(this).closest('li').toggleClass('active');
			});
			//Hamburger js start
			$('.hamburgerLinkGarage').click(function (){
				$("#js-shop-1").hide();
				$(".hamburgerContainer").removeClass('animationAdd');
				$("#" + 'toggle-hamburger-garage' + '-' + '1').show();
			});
			$('.hamburgerLinkShop').click(function (){
				$("#" + 'toggle-hamburger-garage' + '-' + '1').hide();
				$("#js-shop-1").show();
				$("#js-shop-1").addClass('animationAdd');
			});
			$('.back-to-garage').click(function () {
				showHamburgerMenuOption2();
			});
			function showHamburgerMenuOption2()
			{
				$('#toggle-hamburger-garage').addClass('active');
				$('#afg-change-vehicle-modal').hide();
				$("#" + 'toggle-hamburger-garage' + '-' + '1').show();
				$('.garageInnerContainer').css({
					'display': 'block',
				});
			}
			$('.backText').click(function (e) {
				e.preventDefault();
				let backmenuId = $(this).attr("data-id");
				let backmenuType = $(this).attr("data-attr");
				$("#" + backmenuId + '-' + backmenuType).removeClass('animationAdd');
			});
			$('.hamburgerLink').click(function (e) {
				e.preventDefault();
				let hmenuId = $(this).attr("data-id");
				let hmenuType = $(this).attr("data-attr");
				$("#" + hmenuId + '-' + hmenuType).addClass('animationAdd');
			});
			$('.activeShopMenu').click(function () {
				let smenuId = $(this).attr("data-id");
				let smenuType = $(this).attr("data-attr");
				activeShopMenuData(smenuId,smenuType);
			});
			function activeShopMenuData(id, optionType)
			{
				let shop = $("#" + id + '-' + optionType);
				$("#" + id + '-' + optionType).addClass('animationAdd');
				shop.show();
			}
			$('.closeAllModals').click(function () {
				$(".modal").hide();
			});
			//Hamburger js end
		},

		fancyBoxController: function () {
			$(document.body).on('click', '.vipProductLink', function(e) {
				let $link = $(this),
					href = $link.attr('href');

				e.preventDefault();
				$.fancybox({
					type: 'iframe',
					href: href,
					autoCenter: true,
					wrapCSS: 'customFancyBox vipContent'
				});
			});

			$(document.body).on('click', '.sale-price-details', function(e) {
				e.preventDefault();
				$.fancybox({
					content: `<div class="p-3 bg-white">
									<p class="custom-font-weight-600" style="font-size: 18px">Saving calculation</p>
									<p style="font-size: 14px">Pricing on SonicElectronix.com may use verbiage for "sale", "price break", "savings", "special"
										or reflect strike-through pricing in combination with a selling price when a product's price has changed
										within the past 90 days on our website or on third-party websites we advertise and/or sell products to.
									</p>
								</div>`,
					autoCenter: true,
					autoSize: false,
					height: 'auto',
					helpers: {
						overlay: {
							locked: true
						}
					},
					wrapCSS: 'customFancyBox salePriceMessage'
				});
			});

			$(document.body).on('click', '.fancyBoxModal', function(e) {
				let $link = $(this),
					href = $link.attr('href');

				e.preventDefault();
				$.fancybox({
					type: 'iframe',
					href: href,
					autoCenter: true,
					iframe: {
						preload: false
					},
					wrapCSS: 'customFancyBox'
				});
			});

		},
		whyShopWithUsButtonController: function () {
			let whyShopSonicBtn = $('.whyShopSonicBtn');

			if (whyShopSonicBtn.length) {
				let whyShopSonicContainer = $('.whyShopSonicContainer'),
					cardHeaderHeight = 60,
					scale = Math.min(
						(window.innerHeight - $('#main-navigation-wrapper').innerHeight() - whyShopSonicBtn.innerHeight() - cardHeaderHeight) / whyShopSonicContainer.innerHeight(),
						1
					),
					shift = (((1 - scale) * 100) / 2);

				whyShopSonicContainer.css({
					transform: "translate(" + shift + "%, " + shift + "%) " + "scale(" + scale + ")"
				});

				whyShopSonicBtn.click(function() {
					whyShopSonicBtn.find('.bi-chevron-up').toggleClass('d-none');
					whyShopSonicBtn.find('.bi-chevron-down').toggleClass('d-none');
					whyShopSonicContainer.slideToggle('fast');
				});
			}
		},
		advertisingTracker: function () {
			if (!window.IntersectionObserver) { return; }

			var fired = {};

			function pushAdEvent(eventName, link) {
				var zone = link.dataset.zone;
				window.dataLayer = window.dataLayer || [];
				window.dataLayer.push({ ecommerce: null });
				window.dataLayer.push({
					event: eventName,
					ecommerce: {
						creative_name: link.dataset.creativeName || '',
						creative_slot: zone,
						promotion_id: zone,
						promotion_name: link.dataset.alt || '',
						location_id: link.dataset.pageType || '',
						items: [{
							item_id: 'ad_' + zone,
							item_name: link.dataset.alt || '',
							item_category: 'advertisement',
							item_brand: link.dataset.vendor || '',
							creative_name: link.dataset.creativeName || '',
						}]
					}
				});
			}

			var observer = new IntersectionObserver(function (entries) {
				entries.forEach(function (entry) {
					var wrap = entry.target;
					var link = wrap.querySelector('.adZoneLink');
					if (!link) { return; }
					var zone = link.dataset.zone;

					if (entry.isIntersecting && entry.intersectionRatio >= 0.5) {
						if (fired[zone] || wrap._adViewTimer) { return; }
						wrap._adViewTimer = setTimeout(function () {
							if (fired[zone]) { return; }
							fired[zone] = true;
							observer.unobserve(wrap);
							pushAdEvent('view_promotion', link);
						}, 1000);
					} else if (wrap._adViewTimer) {
						clearTimeout(wrap._adViewTimer);
						wrap._adViewTimer = null;
					}
				});
			}, { threshold: [0, 0.5] });

			document.querySelectorAll('.adZoneWrap').forEach(function (wrap) {
				observer.observe(wrap);
			});

			// All banner links use target="_blank" so the current page never unloads on click;
			// dataLayer.push() completes synchronously before the new tab opens, providing the
			// same delivery guarantee as sendBeacon without needing it.
			document.addEventListener('click', function (e) {
				var link = e.target.closest('.adZoneLink');
				if (!link) { return; }
				pushAdEvent('select_promotion', link);
			});
		},
		firstTimeUserEmailSignup: function () {
			$('.firstTimeUserSignUp').click(function() {
				let email = $('#customer_signup_email').val(),
					signUpError = $('#signUpError');
				if(email === '') {
					signUpError.show().html('Please enter a valid e-mail address to subscribe to our newsletter');
				} else {
					$.ajax({
						type: "POST",
						url: '/customer/newsletterSubscribe',
						data: {
							'email': email,
							'signup_source': 'signup_popup'
						},
						success: function (data) {
							if ((typeof data === 'object') && (data !== null)) {
								if (data.success) {
									$('.signUpsuccessMessage').removeClass('d-none');
									$('.emailFormBodySection').hide();
								} else {
									signUpError.show().html(data.alertMessage);
								}
							} else {
								signUpError.show().html('Something went wrong');
							}
						}
					});
				}
			});
		}
	};

	// Expose the necessary methods only
	return {
		customSlider: function () {
			mainTasks.customSlider();
		},
		/**
		 * This runIt executes at the end of the document, NOT on ready event.
		 * @returns {undefined}
		 */
		runIt: function () {
			mainTasks.render();
		}
	};
})();

// Expose the main method
GlobalInIt.runIt();
